import {z} from 'zod';

import i18n from '@dms/i18n';

export const AutoLogoutFormSchema = z.object({
  period: z
    .string({required_error: i18n.t('general.validations.fieldIsRequired')})
    .min(1, i18n.t('general.validations.fieldIsRequired')),
});

export type AutoLogoutFormSchemaType = z.infer<typeof AutoLogoutFormSchema>;
